import { ArrowLeftOutlined } from "@ant-design/icons";
import { Button, Col, Divider, Image, Row } from "antd";
import React, { useEffect, useState } from "react";
import ReactPlayer from "react-player";
import { useHistory, useLocation, useParams } from "react-router-dom";
import { AdminService } from "../../../services/AdminService";

const NewsDetails = () => {
  // @ts-ignore
  const location = useLocation();
  const router = useHistory();
  // @ts-ignore
  const { id } = useParams();
  const [item, setItem] = useState(null);
  const [initialRender, setInitialRender] = useState(true);
  const [oldID, setOldID] = useState(0);
  function createMarkup(gelenDetay) {
    return {
      __html: gelenDetay,
    };
  }
  // @ts-ignore
  const { veri } = location.state || { veri: null };

  useEffect(() => {
    if (initialRender || id !== oldID) {
      setOldID(id);
      setInitialRender(false);
      if (veri === null) {
        AdminService.getNewsById(id).then((data) => {
          console.log(data.data);
          setItem(data.data);
        });
      } else {
        setItem(veri);
      }
    }
  }, [id, initialRender, oldID, veri]);
  return (
    item && (
      <div className="overflow-hidden container mx-auto max-w-4xl px-2 py-10">
        <Button
          onClick={() => router.goBack()}
          icon={<ArrowLeftOutlined />}
          type="primary"
          ghost
        >
          Go Back
        </Button>
        <br />
        <br />
        <p className="font-extrabold text-2xl text-red-600">{item.title}</p>
        <p className="text-lg text-gray-500">{item.description}</p>
        {item.images.map(
          (i) =>
            i.isTop && (
              <Image
                key={i.id}
                preview={false}
                style={{
                  maxWidth: "800px",
                  border: "3px solid #fff",
                  boxShadow: "0 0 5px #eee",
                }}
                src={process.env.REACT_APP_FILES_BASEURL + i.url}
                alt=""
              />
            )
        )}
        <br />
        <br />
        <Row align="middle" gutter={[10, 10]}>
          {item.videos.map(
            (video) =>
              video.isTop && (
                <Col
                  key={video.id}
                  style={{
                    width: "100%",
                  }}
                >
                  <div className="player-wrapper">
                    <ReactPlayer
                      url={video.url}
                      className="react-player"
                      width="100%"
                      height="100%"
                      controls={true}
                    />
                  </div>
                </Col>
              )
          )}
        </Row>
        <br />
        <br />
        <div
          dangerouslySetInnerHTML={createMarkup(item.details)}
          className="booker"
        />
        <br />
        {item.images.length > 1 && (
          <div className="max-w-3xl">
            <Divider orientation="left">Image Gallery</Divider>
            <Image.PreviewGroup>
              <Row align="middle" gutter={[10, 10]}>
                {item.images.map(
                  (imaj) =>
                    !imaj.isTop && (
                      <Col key={imaj.id}>
                        <Image
                          className="gallery-image"
                          width={200}
                          src={process.env.REACT_APP_FILES_BASEURL + imaj.url}
                        />
                      </Col>
                    )
                )}
              </Row>
            </Image.PreviewGroup>
          </div>
        )}
        {item.videos.length > 0 && (
          <div className="max-w-3xl">
            <Divider />

            <Row align="middle" gutter={[10, 10]}>
              {item.videos.map(
                (video) =>
                  !video.isTop && (
                    <Col
                      key={video.id}
                      style={{
                        width: "100%",
                      }}
                    >
                      <div className="player-wrapper">
                        <ReactPlayer
                          url={video.url}
                          className="react-player"
                          width="100%"
                          height="100%"
                          controls={true}
                        />
                      </div>
                    </Col>
                  )
              )}
            </Row>
          </div>
        )}
      </div>
    )
  );
};

export default NewsDetails;
